import { useEffect, useRef, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { gsap } from "gsap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faDownload,
  faListOl,
  faPen,
} from "@fortawesome/free-solid-svg-icons";

import { useIncrementFilesDown } from "../../hooks/useIncrementFilesDown";
import { nombresCiclos } from "../../helpers/nombresCiclos";

import styles from "./MaterialDownloader6Col.module.scss";

export const MaterialDownloader6Col = ({ data, numeroDeDescargas = true }) => {

  const downloader = useRef(null);
  const { incrementFilesDown } = useIncrementFilesDown();


  const handleCkickPDF = (file, id = "sinId") => {
    try {
      // console.log(id);
      window.open(file);
      incrementFilesDown(id);
    } catch (error) {
      console.error("Error en handleCkickPDF:", error);
    }
  };

  const [over, setOver] = useState(false);
  const [out, setOut] = useState(true);
  const mouseOver = () => {
    setOver(true);
    setOut(false);
  };
  const mouseOut = () => {
    setOver(false);
    setOut(true);
  };

  useEffect(() => {
    if (over) {
      gsap.to(downloader.current, { top: 0, duration: 0.2, ease: "ease.out" });
    }
  }, [over]);

  useEffect(() => {
    if (out) {
      gsap.to(downloader.current, { top: "-100%", duration: 0.2, ease: "ease.out" });
    }
  }, [out]);

  return (
    <Col xs={12} md={12} className={`${styles.materialDownloader6Col}`}>
      <Row className={`${styles.contenido}`}>
        <Col xs={12} className={`${styles.contenidoDescription}`}>{data.description}</Col>
        <Col xs={5} md={4} className={`${styles.downloadIconCoantainer} p-0 m-0`}>
          <Col ref={downloader} className={`${styles.iconDownload}`}>
            <FontAwesomeIcon icon={faDownload} />
            {numeroDeDescargas ? (
              <h5><span>{data.descargas} Descargas realizadas</span></h5>
            ):
            (
              <h5><span>Descargar el documento</span></h5>
            )
            }
          </Col>
          <Col className={`${styles.tipo}`}>
            {
              data.tipo === "Actividad" && (
                <>
                  <Row className={`${styles.tipoRow}`}>
                    <Col xs={7} md={6}>
                      <FontAwesomeIcon icon={faPen} size='xs' />
                    </Col>
                    <Col xs={12} className=""><p>Actividad</p></Col>

                  </Row>
                </>
              )
            }
            {
              data.tipo === "Investigación" && (
                <>
                  <Row className={`${styles.tipoRow}`}>
                    <Col xs={7} md={6}>
                      <FontAwesomeIcon icon={faBook} size='xs' />
                    </Col>
                    <Col xs={12} className=""><p>Investigación</p></Col>
                  </Row>
                </>
              )
            }
            {
              data.tipo === "Crucigrama" && (
                <>
                  <Row className={`${styles.tipoRow}`}>
                    <Col xs={7} md={6}>
                      <FontAwesomeIcon icon={faListOl} size='xs' />
                    </Col>
                    <Col xs={12} className=""><p>Crucigrama</p></Col>
                  </Row>
                </>
              )
            }
          </Col>
        </Col>
        <Col xs={7} md={8} className={`${styles.ciclosBox}`}>
          <Row className={``}>
            <Col xs={12} className={`${styles.tituloCiclo}`}>Ciclos</Col>
            {data.niveles ? (
              <ul className={``}>
                {data.niveles.map((nivel, index) => (
                  <li key={index} className={`${styles.ciclos} mb-2`}>{nombresCiclos(nivel)}</li>
                ))}
              </ul>
            ) : (
              <ul className={``}>
                {data.inicial && <li className={`${styles.ciclos} mb-2`}>Inicial</li>}
                {data.primerCiclo && <li className={`${styles.ciclos} mb-2`}>Primer Ciclo</li>}
                {data.segundoCiclo && <li className={`${styles.ciclos} mb-2`}>Segundo Ciclo</li>}
                {data.tercerCiclo && <li className={`${styles.ciclos} mb-2`}>Tercer Ciclo</li>}
                {data.secundario && <li className={`${styles.ciclos} mb-2`}>Secundario</li>}
              </ul>
            )}
          </Row>
        </Col>
        <Col xs={12} md={12} className="my-2 w-100 rounded-3 overflow-hidden">
          <Row>
            <Button variant="primary"  
              onClick={() => handleCkickPDF(data.link, data.id)}
              onMouseOver={mouseOver}
              onMouseLeave={mouseOut}
            >Descargar material</Button>
          </Row>
        </Col>
      </Row>

    </Col>
  );
};
